import script from "./header-pc.vue?vue&type=script&setup=true&lang=js"
export * from "./header-pc.vue?vue&type=script&setup=true&lang=js"

import "./header-pc.vue?vue&type=style&index=0&id=d3388e2a&lang=less"

const __exports__ = script;

export default __exports__